import React from "react";
import "./style.scss";
import Button from "../button";
import Modal from "../modal";

interface ModalLayoutProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: React.ReactNode;
  secondaryBtnText?: React.ReactNode;
  closeBtnText?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  width?: number;
  layoutClassName?: string;
  secButtonClass?: string;
  wrapClassName?: string;
  modalFooterClass?: string;
  description?: string;
  rootClassName?: string;
  closable?: boolean;
  viewBtn?: boolean;
  loading?: boolean;
}

const ModalLayout: React.FC<ModalLayoutProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  children,
  footer,
  width = 600,
  layoutClassName,
  secButtonClass,
  wrapClassName,
  rootClassName,
  modalFooterClass,
  closable = true,
  viewBtn = false,
  secondaryBtnText = "submit",
  closeBtnText = "Cancel",
  loading = false,
}) => {
  const footerContent = footer ?? (
    <div
      className={`
    ${modalFooterClass} modal-footer flex items-end
    ${viewBtn ? "justify-between" : "justify-end"}
  `}
    >
      {viewBtn && (
        <div className="flex items-center gap-2">
          <Button
            onClick={onClose}
            className="modal-cancel-btn ant-btn-secondary"
          >
            View Details
          </Button>
        </div>
      )}
      <div className="flex items-end justify-end gap-4">
        {closeBtnText && (
          <Button onClick={onClose} className="ant-btn-secondary">
            {closeBtnText}
          </Button>
        )}
        {secondaryBtnText && (
          <Button
            loading={loading}
            onClick={onConfirm}
            className={`${secButtonClass}`}
          >
            {secondaryBtnText}
          </Button>
        )}
      </div>
    </div>
  );

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={title}
      description={description}
      footer={footerContent}
      width={width}
      className={`modal-layout-frame ${layoutClassName}`}
      wrapClassName={wrapClassName}
      rootClassName={rootClassName}
      closable={closable}
    >
      <div className="modal-layout-body">{children}</div>
    </Modal>
  );
};

export default ModalLayout;
